import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { ShieldCheck, Clock, Zap } from 'lucide-react';
export function HeroSection() {
  const {
    offerState,
    currentPrice
  } = useCountdown();
  const scrollToOffer = () => {
    document.getElementById('offer-stack')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-crema pt-8 pb-16 px-4 md:pt-16 md:pb-24" data-id="element-84">
      <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-85">
        {/* Title - order-2 on mobile (after image), order-1 on desktop (first) */}
        <div className="order-2 md:order-1 w-full" data-id="element-86">
          <h1 className="text-[32px] md:text-[52px] leading-tight font-bold md:text-center" data-id="element-87">
            "Descubrí Por Qué Todas Mis Cremas y Suplementos de Colágeno Eran
            Una Mentira Cara — Y Cómo Revertí la Flacidez de Mi Piel en 60 Días
            Comiendo Diferente"
          </h1>
        </div>

        {/* Image - order-1 on mobile (first), order-2 on desktop (after title) */}
        <div className="order-1 md:order-2 flex justify-center w-full my-8 md:my-10" data-id="element-88">
          <div className="relative w-full max-w-md" data-id="element-89">
            <div className="absolute inset-0 bg-terracota/10 rounded-2xl transform rotate-3 scale-105" data-id="element-90"></div>
            <img src="https://cdn.magicpatterns.com/uploads/jGBS88WQfx7PH7EjTuzoUz/antienvejecimientomkp.png" alt="Alimentación Antienvejecimiento: Colágeno Natural" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl object-cover" data-id="element-91" />
          </div>
        </div>

        {/* Rest of content - order-3 always (after image on both) */}
        <div className="order-3 w-full flex flex-col space-y-6 md:items-center" data-id="element-92">
          <h2 className="text-[24px] md:text-[36px] font-semibold text-marron/80 leading-snug md:text-center" data-id="element-93">
            Para la mujer que ya intentó todo y sigue viendo cómo su piel cede
            silenciosamente cada año. Esto no es otra dieta. Es la bioquímica
            que nadie te explicó — y hoy la tienes por ${currentPrice} USD.
          </h2>

          {offerState === 'LAUNCH' && <div className="bg-rojo/10 border border-rojo/30 rounded-lg p-4 mt-4 md:max-w-2xl" data-id="element-94">
              <p className="text-rojo font-inter text-sm md:text-base" data-id="element-95">
                <strong data-id="element-96">🚨 ALERTA DE LANZAMIENTO:</strong> Este protocolo se
                lanza hoy por primera vez al público general. Durante las
                próximas <strong data-id="element-97">24 horas únicamente</strong>, el acceso
                completo está disponible al precio de fundadora de{' '}
                <strong data-id="element-98">$6.39 USD</strong>. Después de ese tiempo, el precio
                sube a su valor regular de <strong data-id="element-99">$29 USD</strong> y no habrá
                excepciones.
              </p>
            </div>}

          <div className="pt-6 flex flex-col items-center" data-id="element-100">
            <div className="flex items-center space-x-3 mb-4" data-id="element-101">
              <span className="text-gray-400 line-through text-xl font-playfair" data-id="element-102">
                $143
              </span>
              <span className="text-gray-500 line-through text-2xl font-playfair" data-id="element-103">
                $29
              </span>
              <span className="text-terracota text-4xl md:text-5xl font-bold font-playfair" data-id="element-104">
                ${currentPrice} USD
              </span>
            </div>

            <button onClick={scrollToOffer} className="btn-primary w-full md:w-[480px] h-[56px] md:h-[64px] text-[16px] md:text-[18px]" data-id="element-105">
              ✅ SÍ — QUIERO EL SISTEMA POR ${currentPrice} USD →
            </button>

            <div className="flex items-center justify-center space-x-4 mt-4 text-xs md:text-sm text-carbon/70" data-id="element-106">
              <span className="flex items-center" data-id="element-107">
                <Zap className="w-4 h-4 mr-1 text-terracota" data-id="element-108" /> Acceso inmediato
              </span>
              <span className="flex items-center" data-id="element-109">
                <ShieldCheck className="w-4 h-4 mr-1 text-confianza" data-id="element-110" /> Garantía
                30 días
              </span>
              <span className="flex items-center" data-id="element-111">
                <Clock className="w-4 h-4 mr-1 text-rojo" data-id="element-112" /> Solo 24 horas
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}